var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-changePassword" }, [
    _c("div", { staticClass: "o-form" }, [
      _c(
        "div",
        {
          staticClass: "o-form__col",
          class: { "o-form__col--error": _vm.errors.currentPassword }
        },
        [
          _c(
            "div",
            {
              staticClass: "o-input",
              class: {
                "o-input--error": _vm.errors.currentPassword
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentPassword,
                    expression: "currentPassword"
                  }
                ],
                staticClass: "o-input__input",
                class: {
                  valid: _vm.currentPassword
                },
                attrs: {
                  type: "password",
                  name: "currentPassword",
                  id: "currentPassword"
                },
                domProps: { value: _vm.currentPassword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.currentPassword = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "o-input__label",
                  attrs: { for: "currentPassword" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.translations["Existing password"]) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.errors.currentPassword
                ? _c("div", { staticClass: "o-input__error" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errors.currentPassword[0]) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "o-form" }, [
      _c(
        "div",
        {
          staticClass: "o-form__col",
          class: { "o-form__col--error": _vm.errors.newPassword }
        },
        [
          _c(
            "div",
            {
              staticClass: "o-input",
              class: {
                "o-input--error": _vm.errors.newPassword
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPassword,
                    expression: "newPassword"
                  }
                ],
                staticClass: "o-input__input",
                class: {
                  valid: _vm.newPassword
                },
                attrs: {
                  type: "password",
                  name: "newPassword",
                  id: "newPassword"
                },
                domProps: { value: _vm.newPassword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newPassword = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "o-input__label",
                  attrs: { for: "newPassword" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.translations["New password"]) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.errors.newPassword
                ? _c("div", { staticClass: "o-input__error" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errors.newPassword[0]) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "o-form__col" }, [
        _c("div", { staticClass: "o-input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newPasswordRepeat,
                expression: "newPasswordRepeat"
              }
            ],
            staticClass: "o-input__input",
            class: {
              valid: _vm.newPasswordRepeat
            },
            attrs: {
              type: "password",
              name: "newPasswordRepeat",
              id: "newPasswordRepeat"
            },
            domProps: { value: _vm.newPasswordRepeat },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newPasswordRepeat = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "o-input__label", attrs: { for: "repeatPassword" } },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.translations["Repeat new password"]) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-changePassword__action",
          class: {
            "c-changePassword__action--error": _vm.showError,
            "c-changePassword__action--success": _vm.success
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "c-changePassword__button",
              class: { "c-changePassword__button--loading": _vm.isLoading }
            },
            [
              _c(
                "div",
                {
                  staticClass: "o-btn o-btn--filled",
                  on: {
                    click: function($event) {
                      return _vm.updatePassword()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.translations["Update"]) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("inline-loader")
            ],
            1
          ),
          _vm._v(" "),
          _vm.showError
            ? _c("div", { staticClass: "c-changePassword__error" }, [
                _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.success
            ? _c("div", { staticClass: "c-changePassword__success" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.translations["Password updated succesfully"]) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }